module.exports = __webpack_public_path__ + "img/Goed verlicht.81a07d88.png";